// extracted by mini-css-extract-plugin
export default {"formWrapper":"order-detail-form_formWrapper__gkBYn","actionBtnWrapper":"order-detail-form_actionBtnWrapper__IFg0k","nextBtn":"order-detail-form_nextBtn__LNmae"};